"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { routes } from "#/config/routes";
import { useMarket } from "#/store/app/portfolio/market";

import { usePositionsDrawerMarket } from "../positionsDrawer/positionsDrawerMarket";
import { useShowTradePanel } from "../tradePanel/showTradePanel";

export const PortfolioUpdater = () => {
  const { market } = useMarket();
  const { setMarket } = usePositionsDrawerMarket();
  const pathname = usePathname();
  const { setShowTradePanel } = useShowTradePanel();
  const isOnPortfolioPage = pathname.startsWith(routes.portfolio.index);

  useEffect(() => {
    if (isOnPortfolioPage) {
      setShowTradePanel(false);
    }
  }, [setShowTradePanel, pathname, isOnPortfolioPage]);

  // Sync the market in the positions drawer with the global market state
  useEffect(() => {
    setMarket(market);
  }, [market, setMarket]);

  return null;
};
